import * as React from 'react';

import CourseDetailContainer from '../../containers/CourseDetail';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * 章立て情報画面
 * @param props
 */
const CourseDetail: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('CourseDetail_0006')} />
			<CourseDetailContainer {...props} />
		</>
	);
};

export default CourseDetail;



// WEBPACK FOOTER //
// ./src/pages/personal/CourseDetail.tsx